import { render, staticRenderFns } from "./BorrowRequestConfirmation.vue?vue&type=template&id=39aa2f33&"
import script from "./BorrowRequestConfirmation.vue?vue&type=script&lang=js&"
export * from "./BorrowRequestConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports